import _ from "lodash";

export interface NomenclatureType {
  code: number;
  title: string;
}

export class Nomenclature implements NomenclatureType {
  code: number;
  title: string;

  constructor(data?: Nomenclature) {
    this.code = 0;
    this.title = "";
    data && Object.assign(this, data);
  }
}

const n103110 = new Nomenclature({
  code: 103110,
  title: "amountOfPatients.nomenclatureCode[0]",
});
const n103132 = new Nomenclature({
  code: 103132,
  title: "amountOfPatients.nomenclatureCode[1]",
});
const n104215 = new Nomenclature({
  code: 104215,
  title: "amountOfPatients.nomenclatureCode[2]",
});
const n104230 = new Nomenclature({
  code: 104230,
  title: "amountOfPatients.nomenclatureCode[3]",
});
const n104252 = new Nomenclature({
  code: 104252,
  title: "amountOfPatients.nomenclatureCode[4]",
});

const n103213 = new Nomenclature({
  code: 103213,
  title: "amountOfPatients.nomenclatureCode[0]",
});
const n104613 = new Nomenclature({
  code: 104613,
  title: "amountOfPatients.nomenclatureCode[2]",
});
const n104635 = new Nomenclature({
  code: 104635,
  title: "amountOfPatients.nomenclatureCode[3]",
});
const n104591 = new Nomenclature({
  code: 104591,
  title: "amountOfPatients.nomenclatureCode[4]",
});
const n103235 = new Nomenclature({
  code: 103235,
  title: "amountOfPatients.nomenclatureCode[0]",
});
const n103412 = new Nomenclature({
  code: 103412,
  title: "amountOfPatients.nomenclatureCode[1]",
});
const n103434 = new Nomenclature({
  code: 103434,
  title: "amountOfPatients.nomenclatureCode[1]",
});
const n104333 = new Nomenclature({
  code: 104333,
  title: "amountOfPatients.nomenclatureCode[2]",
});
const n104311 = new Nomenclature({
  code: 104311,
  title: "amountOfPatients.nomenclatureCode[3]",
});
const n104296 = new Nomenclature({
  code: 104296,
  title: "amountOfPatients.nomenclatureCode[4]",
});

const singlePatientCodes = [
  [n103110],
  [n103132],
  [n104215],
  [n104230],
  [n104252],
];
const doublePatientCodes001002 = [
  [n103213],
  [n103213, n104613],
  [n103213, n104635],
  [n103213, n104591],
];
const triplePatientCodes001002 = [
  [n103235],
  [n103235, n104613],
  [n103235, n104635],
  [n103235, n104591],
];
const doublePatientCodes003008 = [
  [n103412],
  [n103412, n104333],
  [n103412, n104311],
  [n103412, n104296],
];
const triplePatientCodes003008 = [
  [n103434],
  [n103434, n104333],
  [n103434, n104311],
  [n103434, n104296],
];

export const user001002: { [index: number]: Nomenclature[][] } = {
  1: singlePatientCodes,
  2: doublePatientCodes001002,
  3: triplePatientCodes001002,
};
export const user003008: { [index: number]: Nomenclature[][] } = {
  1: singlePatientCodes,
  2: doublePatientCodes003008,
  3: triplePatientCodes003008,
};

export const getDefaultNomenclatureCodeIndex = (
  date: Date,
  nomenclatures: Nomenclature[][]
): number => {
  const nomenclaturesLength = nomenclatures.length;

  const dayOfTheWeek = date.getDay();
  const hourOfTheDay = date.getHours();
  if (
    (dayOfTheWeek === 6 && hourOfTheDay >= 8) ||
    (dayOfTheWeek === 0 && hourOfTheDay <= 21)
  ) {
    return nomenclaturesLength - 1;
  }
  if (hourOfTheDay < 8 || hourOfTheDay >= 21) {
    return nomenclaturesLength - 2;
  }
  if (hourOfTheDay >= 18 && hourOfTheDay < 21) {
    return nomenclaturesLength - 3;
  }
  return 0;
};

export const nomenclaturesCodes = (
  amountOfPatients: number,
  nihii?: string
): Nomenclature[][] => {
  nihii = nihii || "004";
  const userCodes = _.inRange(Number.parseInt(nihii.slice(-1)), 1, 3)
    ? user001002
    : user003008;
  return userCodes[amountOfPatients];
};
